import * as types from 'vuex-store/mutation-types'
import lazyLoading from './lazyLoading'
import users from './users'
import classes from './classes'
import transactions from './transactions'
import products from './products'
import contracts from './contracts'
import usage from './reports'
import ops from './ops'

// show: meta.label -> name
// name: component name
// meta.label: display label

const state = {
  items: [
    /* {
      name: 'Dashboard',
      path: '/dashboard',
      meta: {
        auth: true,
        icon: 'fa-tachometer',
        link: 'dashboard/index.vue'
      },
      component: lazyLoading('dashboard', true)
    }, */
    users,
    classes,
    products,
    contracts,
    transactions,
    usage,
    ops,
    {
      name: 'Support',
      path: '/support',
      meta: {
        auth: true,
        icon: 'fa-question-circle',
        link: 'support/index.vue'
      },
      component: lazyLoading('support', true)
    }
  ]
}

const mutations = {
  [types.EXPAND_MENU] (state, menuItem) {
    if (menuItem.index > -1) {
      if (state.items[menuItem.index] && state.items[menuItem.index].meta) {
        state.items[menuItem.index].meta.expanded = menuItem.expanded
      }
    } else if (menuItem.item && 'expanded' in menuItem.item.meta) {
      menuItem.item.meta.expanded = menuItem.expanded
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./client/store/modules/menu/index.js